import { HttpClient } from '@angular/common/http';
import { User, UserContract } from '../models/user';
import { environment } from '../../../../environments/environment';
import { map, Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { injectQuery, QueryObserverResult } from '@ngneat/query';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private httpClient = inject(HttpClient);

    private readonly query = injectQuery();

    private userQuery$: Observable<QueryObserverResult<UserContract, Error>>;

    constructor() {
        this.userQuery$ = this.query({
            queryKey: ['current-user'] as const,
            queryFn: () =>
                this.httpClient.get<UserContract>(environment.apiUrl + 'User'),
            throwOnError: true,
            staleTime: Infinity,
            retry: false,
        }).result$;
    }

    getCurrentUser(): Observable<User | undefined> {
        return this.userQuery$.pipe(
            map((user) => {
                const response = user?.data;

                if (!response) {
                    return undefined;
                }

                return Object.assign(new User(), response);
            }),
        );
    }
}
